import {BaseCachedService} from './Core/BaseCachedService';

class SpeciesTypeService extends BaseCachedService {
    get Url() { return super.Url + "/speciesTypes"; }
    get ModelName() { return "Species Type"; }
    get PrimaryKeyProperty() { return "speciesTypeId"; }
}

export const service = new SpeciesTypeService();

